import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setDeck } from './actions';
import { getDecks } from '../Decks/actions';
import { selectDecks, selectDecksLoaded } from '../Decks/selectors';
import { selectDeckPile, selectSettingDeck } from './selectors';
import { Button, Muted, Select } from '../Controls';

const SetDeck = ({ userId }) => {
  const dispatch = useDispatch();
  const deckPile = useSelector((state) => selectDeckPile(state, { userId }));
  const decks = useSelector(selectDecks);
  const decksLoaded = useSelector(selectDecksLoaded);
  const setting = useSelector(selectSettingDeck);
  const [deckId, changeDeckId] = useState('');

  useEffect(() => {
    if (decks.size) {
      changeDeckId(decks.first().get('id'));
    }
  }, [decks]);

  useEffect(() => {
    dispatch(getDecks());
  }, [dispatch]);

  if (deckPile) {
    return null;
  }

  if (!decksLoaded) {
    return <Muted>Loading decks…</Muted>;
  }

  return (
    <form
      onSubmit={(e) => { e.preventDefault(); dispatch(setDeck(deckId)); }}
      style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}
    >
      <Select aria-label="Deck" onChange={(e) => changeDeckId(e.target.value)} value={deckId}>
        {decks.map((deck) => (
          <option key={deck.get('id')} value={deck.get('id')}>{deck.get('name')}</option>
        ))}
      </Select>
      <Button $primary disabled={setting}>{setting ? 'Shuffling…' : 'Use this deck'}</Button>
    </form>
  );
};

SetDeck.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default SetDeck;
